import Ball from './ball'

export default class Bucket {
  balls: Ball[] = []
}
